module.exports = __webpack_public_path__ + "img/trash.5f9ca53e.svg";